import { render, staticRenderFns } from "./list-inside.vue?vue&type=template&id=54c2d5b0&scoped=true"
import script from "./list-inside.vue?vue&type=script&lang=js"
export * from "./list-inside.vue?vue&type=script&lang=js"
import style0 from "./list-inside.vue?vue&type=style&index=0&id=54c2d5b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c2d5b0",
  null
  
)

export default component.exports